export default __webpack_public_path__ + "static/media/ocr.5991dac6.jpg";